"use strict";
var userDetails;

function getUserInformation(user, callback) {
  var endpoint = apiUrl + "/patient/getPatientInfo?userId=" + user;
  $.ajax({
    url: endpoint,
    headers: {
      'Authorization': "Bearer ".concat(sessionStorage.getItem('token'))
    },
    method: 'GET',
    data: "",
    success: function success(data) {
      //clear email to not send email once they get past the first question
      userDetails = JSON.stringify(data); //console.log("WRITE USER DETAILS: ");
      //console.log(userDetails);

      if (callback != undefined) {
        callback(data);
      }
    }
  });
}

(function ($) {
  $.fn.scrollTo = function (delay) {
    $('html, body').stop(true, true).delay(delay).animate({
      scrollTop: $(this).offset().top + 'px'
    }, 'fast');
    return this; // for chaining...
  };
})(jQuery);

function setPageContainerHeight() {
  //Calculates & changes page-container height to maintain body at 100% height
  //Used on both landing & account page
  var bodyHeight = $('body').outerHeight();
  var navBarHeight = $('.ac-navbar').outerHeight();
  var footerHeight = $('#footer').outerHeight();
  var contentHeight = bodyHeight - (navBarHeight + footerHeight) - 10;
  $('.page-container').height(contentHeight);
}
//# sourceMappingURL=global.js.map
